<template>
    <v-card style="max-width: 968px; margin: auto" :loader="loader">
        <!-- <div v-padding="3">
            <v-row>
                <v-col>
                    <v-text type="title">Физические лица</v-text>
                </v-col>

                <v-col>
                    <v-text type="title" v-margin.left="3">Юридические лица</v-text>
                </v-col>
            </v-row>
        </div> -->

        <tariff-details :tariff="tariff" />

        <v-animation-height>
            <v-row>
                <v-col>
                    <div v-if="hasBothCreditRatings">
                        <v-expansion>
                            <v-text type="caption" slot="caption">
                            </v-text>
                            <div slot="title">
                                <div>
                                    <v-text type="subheadling">
                                        Кредитный рейтинг
                                    </v-text>
                                    <v-label orange
                                        v-if="individualProducts.find(x => x.id == 61).freeCount > 0 || individualProducts.find(x => x.id == 70).freeCount > 0">
                                        Есть бесплатные запросы
                                    </v-label>
                                </div>
                            </div>

                            <request-product v-model="selectedProduct" :tariff="hasTariff"
                                :product="individualProducts.find(x => x.id == 61)"
                                :disabled="isProductDisabled(individualProducts.find(x => x.id == 61))"
                                :addSeparator="true" />
                            <request-product v-model="selectedProduct" :tariff="hasTariff"
                                :product="individualProducts.find(x => x.id == 70)"
                                :disabled="isProductDisabled(individualProducts.find(x => x.id == 70))" />
                        </v-expansion>
                        <v-separator />

                    </div>

                    <div v-if="hasBothExtendedCreditRatings">
                        <v-expansion>
                            <v-text type="caption" slot="caption">
                            </v-text>
                            <div slot="title">
                                <div>
                                    <v-text type="subheadling">
                                        Кредитный рейтинг расширенный
                                    </v-text>
                                    <v-label orange
                                        v-if="individualProducts.find(x => x.id == 67).freeCount > 0 || individualProducts.find(x => x.id == 71).freeCount > 0">
                                        Есть бесплатные запросы
                                    </v-label>
                                </div>
                            </div>

                            <request-product v-model="selectedProduct" :tariff="hasTariff"
                                :product="individualProducts.find(x => x.id == 67)"
                                :disabled="isProductDisabled(individualProducts.find(x => x.id == 67))"
                                :addSeparator="true" />
                            <request-product v-model="selectedProduct" :tariff="hasTariff"
                                :product="individualProducts.find(x => x.id == 71)"
                                :disabled="isProductDisabled(individualProducts.find(x => x.id == 71))" />
                        </v-expansion>
                        <v-separator />

                    </div>

                    <request-product v-model="selectedProduct"
                        v-for="product in individualProducts.filter(x => hasBothCreditRatings ? (x.id != 61 && x.id != 70) : true).filter(x => hasBothExtendedCreditRatings ? (x.id != 67 && x.id != 71) : true)"
                        :tariff="hasTariff" :product="product" :disabled="isProductDisabled(product)"
                        :addSeparator="true" :key="product.id" />
                </v-col>

                <v-col>
                    <modal-survey />

                    <request-product v-model="selectedProduct" v-for="product in legalProducts" :tariff="hasTariff"
                        :product="product" :disabled="isProductDisabled(product)" :addSeparator="true"
                        :key="product.id" />
                </v-col>
            </v-row>

            <div v-padding="3">
                <close-tariff v-if="isCloseTariff && !selectedProductHasFreeRequests" :btnIsDisabled="false"
                    @closed="$emit('tariff-closed')" />

                <v-row v-else-if="isInsufficientFunds && !selectedProductHasFreeRequests" align-items="center">
                    <v-col xs="8">
                        <v-text v-if="hasTariff" danger>
                            Остатка на тарифе недостаточно.
                            <v-text v-if="!isCloseTariff" danger>
                                Тариф не может быть закрыт так как не все запросы были обработаны.
                            </v-text>
                        </v-text>
                        <v-text v-else danger>
                            Для получения доступа к проверкам выберете и оплатите подходящий тариф
                        </v-text>
                    </v-col>
                    <v-col v-if="!hasTariff" v-text-align.right>
                        <v-router-link :to="{ name: 'tariff' }">
                            <v-button primary>
                                Выбрать тариф
                            </v-button>
                        </v-router-link>
                    </v-col>
                </v-row>

                <v-row v-else align-items="center">
                    <v-col></v-col>
                    <v-col v-text-align.right>
                        <v-text v-if="!selectedProductHasFreeRequests && !selectedProductIsPromoted" bold
                            v-margin.right="3">
                            Итого: {{ total }} руб<span v-if="selectedProduct && isMonitoringProduct(selectedProduct)">
                                за месяц</span>
                        </v-text>

                        <v-spinner :active="isSendingProducts">
                            <v-button v-if="selectedProductIsPromoted" :disabled="isNextDisabled" @click="handleNext" primary>
                                перейти
                            </v-button>
                            <v-button v-else :disabled="isNextDisabled" @click="handleNext" primary>
                                далее
                            </v-button>
                        </v-spinner>
                    </v-col>
                </v-row>
            </div>
        </v-animation-height>
    </v-card>
</template>

<script>
import { RequestProduct } from '../requestProduct';
import TariffDetails from './TariffDetails.vue';
import CloseTariff from "./CloseTariffContainer.vue";
import { ModalSurvey } from '../../modal/Survey';

export default {
    components: {
        CloseTariff,
        RequestProduct,
        ModalSurvey,
        TariffDetails,
    },
    name: 'request-products',
    props: {
        onCloseTariff: Function,
        onNext: Function,
        loader: Boolean,
        // hasTariff: Boolean,
        balance: {
            type: Number,
            default: 0,
        },
        tariff: Object,
        individualProducts: {
            type: Array,
            default() {
                return [];
            }
        },
        legalProducts: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            isSendingProducts: false,
            availableProducts: [],
            selectedProduct: null
        }
    },
    methods: {
        isProductDisabled(product) {
            if (this.isClosingTariff || this.isSendingProducts) {
                return true;
            }

            return !product.isEnable;
        },

        isMonitoringProduct(product) {
            const monitoringProductIds = [9];
            return monitoringProductIds.includes(product.id);
        },

        handleNext() {
            if (this.isSendingProducts) {
                return;
            }

            this.isSendingProducts = true;

            if (this.selectedProduct && this.selectedProduct.id === -1) {
                this.isSendingProducts = false;
                this.$router.push({ name: 'refinanceAnalysis' });
                return;
            }

            this.onNext([this.selectedProduct.id])
                .then((res) => {
                    this.$router.push({ name: 'requestProfile' });
                });
        },
    },
    computed: {
        hasTariff() {
            return this.tariff && !!this.tariff.title;
        },

        total() {
            return this.selectedProduct ? this.selectedProduct.cost : 0;
        },

        selectedProductHasFreeRequests() {
            return this.selectedProduct && !!this.selectedProduct.freeCount
        },

        selectedProductIsPromoted() {
            return this.selectedProduct && this.selectedProduct.id === -1
        },

        isHasFreeRequests() {
            return this.individualProducts.some((product) => product.freeCount > 0)
                || this.legalProducts.some((product) => product.freeCount > 0);
        },

        isNextDisabled() {
            return this.selectedProduct == null;
        },

        isInsufficientFunds() {
            return this.isHasFreeRequests
                ? this.balance < this.total
                : this.balance <= 0 || this.balance < this.total;
        },

        isCloseTariff() {
            return this.hasTariff && this.tariff.isClosable && this.tariff.balance < this.total;
        },

        hasBothCreditRatings() {
            return this.individualProducts.some(x => x.id == 61) && this.individualProducts.some(x => x.id == 70);
        },

        hasBothExtendedCreditRatings() {
            return this.individualProducts.some(x => x.id == 67) && this.individualProducts.some(x => x.id == 71);
        }
    }
}
</script>


// WEBPACK FOOTER //
// RequestProducts.vue?fa0848e0